import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import { useIntl } from 'react-intl';
import { SearchBarContext, SubmitOnEnterOverSelectCallback } from '../../../../components/SearchBar';
import SearchBarRow from '../../../../components/SearchBar/SearchBarRow';

const PrimarySearchItems = () => {
  const intl = useIntl();
  const { register } = useContext(SearchBarContext);

  return (
    <SearchBarRow>
      <div className="form-group">
        <label>{intl.formatMessage({ id: 'courses.id-field' })}</label>
        <input type="number" className="form-control" {...register('id')}></input>
      </div>

      <div className="form-group">
        <label>{intl.formatMessage({ id: 'courses.title-field' })}</label>
        <input className="form-control" {...register('title')}></input>
      </div>

      <div className="form-group">
        <label>{intl.formatMessage({ id: 'courses.visibility-field' })}</label>
        <select className="form-control" {...register('is_public')} onKeyUp={SubmitOnEnterOverSelectCallback}>
          <option value="">{intl.formatMessage({ id: 'shared.dropdown.please-select' })}</option>
          <option value="true">{intl.formatMessage({ id: 'shared.public' })}</option>
          <option value="false">{intl.formatMessage({ id: 'shared.private' })}</option>
        </select>
      </div>

      <div className="form-group">
        <label>{intl.formatMessage({ id: 'courses.status-field' })}</label>
        <select className="form-control" {...register('status')} onKeyUp={SubmitOnEnterOverSelectCallback}>
          <option value="">{intl.formatMessage({ id: 'shared.dropdown.please-select' })}</option>
          <option value="draft">{intl.formatMessage({ id: 'shared.status.draft' })}</option>
          <option value="published">{intl.formatMessage({ id: 'shared.status.published' })}</option>
          <option value="archived">{intl.formatMessage({ id: 'shared.status.archived' })}</option>
        </select>
      </div>
    </SearchBarRow>
  );
};

const SecondarySearchItems = (props) => {
  const intl = useIntl();
  const { register, getValues, setValue } = useContext(SearchBarContext);

  return (
    <>
      <SearchBarRow>
        <div className="form-group form-check">
          <label htmlFor="show_archived">
            <input
              type="checkbox"
              name="show_archived"
              id="show_archived"
              defaultChecked={getValues('show_archived') == 'true'}
              onChange={(e) =>
                e.currentTarget.checked ? setValue('show_archived', 'true') : setValue('show_archived', null)
              }
            />
            {intl.formatMessage({ id: 'courses.show-archived-field' })}
          </label>
        </div>
      </SearchBarRow>
      {props.organisations && (
        <div className="searchbar-secondary-items extended">
          <SearchBarRow>
            <div className="form-group">
              <label>{intl.formatMessage({ id: 'courses.organisation-field' })}</label>
              <select className="form-control" {...register('organisation_id')} onKeyUp={SubmitOnEnterOverSelectCallback}>
                <option key="0" value="">
                  {intl.formatMessage({ id: 'shared.dropdown.please-select' })}
                </option>
                {props.organisations.map((org) => {
                  return (
                    <option key={org.id} value={org.id}>
                      {org.name}
                    </option>
                  );
                })}
              </select>
            </div>
          </SearchBarRow>
        </div>
      )}
    </>
  );
};

SecondarySearchItems.propTypes = {
  organisations: PropTypes.array.isRequired,
};

export { PrimarySearchItems, SecondarySearchItems };
